import { createI18n } from 'vue-i18n'
import zh from './zh'
import en from './en'
import nl from './nl'
// import pl from './pl'
import { set, get } from '../utils/Cache.js'


const supportLanguage = ['zh', 'en', 'nl', 'zh-CN']

console.log('navigator.language',navigator.language);
const browserLang = supportLanguage.includes(navigator.language) ? navigator.language : 'en'
console.log('浏览器语言',browserLang);
var lang = JSON.parse(get('locale')) ? JSON.parse(get('locale')) : browserLang
console.log('当前语言',lang);
set('locale', lang)

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: lang,
  fallbackLocale: 'en',
  messages: {
    en: en,
    zh: zh,
    'zh-CN': zh,
    nl: nl
    // pl: pl
  }
})